interface IconProps {
  size?: number | string;
  color?: string;
  className?: string;
}

export function ChevronRightIcon({ size = 24, color, className }: IconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 16 16"
      fill="currentColor"
      style={color ? { color } : undefined}
      className={className}
      aria-hidden="true"
    >
      <path d="M12.5312 7.46875C12.825 7.7625 12.825 8.2375 12.5312 8.52812L6.53125 14.5312C6.2375 14.825 5.7625 14.825 5.47187 14.5312C5.18125 14.2375 5.17812 13.7625 5.47187 13.4719L10.9406 8.00312L5.46875 2.53125C5.175 2.2375 5.175 1.7625 5.46875 1.47187C5.7625 1.18125 6.2375 1.17812 6.52812 1.47187L12.5312 7.46875Z" />
    </svg>
  );
}
